import React from 'react';
import PropTypes from 'prop-types';
import Svg, { Defs, LinearGradient, G, Path } from 'svgs';

const BgLogins = props => (
  <Svg width={props.width} height={props.height} viewBox="0 0 1024 576">
    <Defs>
      <LinearGradient id="Gradient1" x1="0" x2="0" y1="0" y2="1">
        <stop offset="0%" stopColor="#66BA70" />
        <stop offset="40.417%" stopColor="#6AA84F" />
        <stop offset="55.001%" stopColor="#6AA84F" />
        <stop offset="100%" stopColor="#74A133" />
      </LinearGradient>
      <linearGradient id="Gradient2" x1="0" x2="0" y1="0" y2="1">
        <stop offset="0%" stopColor="#013F4A" />
        <stop offset="100%" stopColor="#0B3C45" />
      </linearGradient>

    </Defs>
    <G fill="none" fillRule="evenodd">
      <Path
        fill="url(#Gradient1)"
        fillRule="nonzero"
        d={
          'M1023.583 575.614H0V.299C.831-.218 1.767.092 2.702' +
          '.092h1018.076c3.429 0 3.117-.413 3.117 2.997v569.8' +
          '38c-.104.827.208 1.757-.312 2.687z'
        }
      />
      <Path
        fill="url(#Gradient1)"
        fillRule="nonzero"
        d={
          'M1023.583 575.614H0V.299C.831-.218 1.767.092 2.702' +
          '.092h1018.076c3.429 0 3.117-.413 3.117 2.997v569.8' +
          '38c-.104.827.208 1.757-.312 2.687z'
        }
      />
      <G fillRule="nonzero">
        <Path
          fill="#2E9633"
          fillOpacity=".3"
          d={
            'M1012.63 553.368c.207 5.401.103 10.907.103 16.308 ' +
            '0 2.7.622 4.363-1.452 5.505-1.555.831-5.184.208-7.' +
            '154.208-10.783.104-21.67-.208-32.454-.311-20.011-.' +
            '208-40.023.207-60.034.207 1.14-9.868 5.184-17.762 ' +
            '14.412-22.02 4.77-2.182 10.472-3.844 15.76-2.494 3' +
            '.733.935 6.325 4.363 9.85 2.493 3.422-1.766 5.703-' +
            '7.063 9.436-9.245 4.77-2.908 10.369-3.843 15.864-2' +
            '.908 10.68 1.974 16.694 8.83 21.567 17.866 3.629-3' +
            '.843 8.917-5.713 14.101-5.609z'
          }
        />
        <Path
          fill="#073B39"
          fillOpacity=".3"
          d={
            'M702.67 395.67c1.449-2.29 2.484-3.54 3.312-4.79 4.' +
            '346-6.459 9.52-11.875 15.73-16.458 3.311-2.292 6.8' +
            '3-4.375 10.97-2.083 3.932 2.291 4.967 6.458 4.76 1' +
            '0.832-.207 3.959-1.449 7.5-3.312 10.833-2.276 3.95' +
            '8-4.967 7.708-7.45 11.666-.829 1.459-2.07 2.084-3.' +
            '726 1.875-22.354-.416-44.5 1.875-66.854 1.667-4.55' +
            '3 0-4.967-.417-5.174-5-.207-4.166.828-7.916 2.69-1' +
            '1.458 2.484-5 7.038-7.5 13.868-4.791 2.484 1.042 4' +
            '.76 2.708 7.244 4.166 1.45-.625.828-2.083 1.035-3.' +
            '124 1.035-6.458 3.312-12.5 7.037-17.916a33.941 33.' +
            '941 0 0 1 3.519-4.167c4.346-3.958 8.279-3.541 11.5' +
            '9 1.459 3.312 5.208 4.761 11.249 4.968 17.499 0 3.' +
            '125-.207 5.833-.207 9.79z'
          }
        />
        <Path
          fill="#083B39"
          fillOpacity=".3"
          d={
            'M828.54 89.806c.42-2.899.84-4.969 1.05-7.04.42-2.4' +
            '84 1.26-4.76 2.729-6.831 1.89-2.277 3.57-2.277 5.8' +
            '78-.207 1.47 1.45 2.1 3.312 2.94 5.176 2.1 6.003 2' +
            '.939 12.214 3.569 18.632 1.47-.414 1.89-1.863 2.52' +
            '-2.692 2.728-4.14 5.458-8.28 9.447-11.386 3.569-2.' +
            '691 5.878-2.07 6.718 2.277 1.26 6.211-1.26 11.594-' +
            '5.249 16.355-.63.828-1.68.828-2.73 1.035-9.866 1.0' +
            '36-19.734.414-29.601-.207-1.05 0-2.1-.207-2.73-.82' +
            '8-4.828-4.347-8.397-9.523-8.817-16.148-.21-4.347 2' +
            '.1-5.796 6.298-4.968 3.78.828 5.669 3.726 7.978 6.' +
            '832zM368.373 57.385c.104-1.762.209-3.11.523-4.353.' +
            '209-.829.522-1.554.94-2.28 1.045-1.658 2.09-1.658 ' +
            '3.345-.31.627.725.94 1.554 1.254 2.383.941 3.005 1' +
            '.568 6.115 1.673 9.224.94.207.94-.622 1.15-1.037 1' +
            '.358-2.176 2.822-4.352 4.912-5.907 1.882-1.45 3.03' +
            '1-1.14 3.345 1.244.418 2.901-.627 5.492-2.404 7.87' +
            '6-.418.622-1.15.622-1.777.725-4.913.415-9.825.311-' +
            '14.738-.207-.627-.103-1.045-.31-1.568-.725-1.986-1' +
            '.866-3.345-4.146-3.972-6.737-.313-1.14-.313-2.383.' +
            '732-3.212 1.15-.933 2.404-.311 3.554.207 1.254.622' +
            ' 1.777 1.762 3.03 3.109zM565.725 401.951c.247-1.6.' +
            '37-3.077.618-4.432.618-2.708 2.101-4.924 3.46-4.55' +
            '5 1.978.493 2.72 2.34 3.214 4.186 1.112 3.57 1.607' +
            ' 7.264 2.101 11.203 1.483-2.092-6.55 4.556-5.314 2' +
            '.832.988-1.354-.248.493-6.056 0-.495 0-.99-.123-1.' +
            '36-.492-2.719-2.709-4.944-5.664-5.067-9.603-.124-2' +
            '.586 1.36-3.57 3.831-2.832 1.36.246 1.978.739 4.57' +
            '3 3.693z'
          }
        />
        <Path
          fill="#21B6A0"
          fillOpacity=".284"
          d={
            'M738.794 174.8c-.413-2.688-.62-5.168-1.032-7.442-1' +
            '.031-4.547-3.506-8.267-5.775-7.647-3.3.826-4.538 3' +
            '.927-5.363 7.027-1.856 5.995-2.68 12.196-3.506 18.' +
            '81-2.475-3.514-4.538-6.614-6.6-9.508-1.65-2.274-3.' +
            '507-4.34-5.982-5.788-2.68-1.86-3.712-1.24-5.362 1.' +
            '654-2.063 3.927.825 14.055 4.744 17.776.825.827 1.' +
            '856.827 2.681.827 9.9 1.033 19.8.62 29.495-.207.82' +
            '5 0 1.65-.207 2.269-.827 4.537-4.547 8.25-9.508 8.' +
            '456-16.122.206-4.341-2.269-5.995-6.394-4.754-2.269' +
            '.413-3.3 1.24-7.631 6.2z'
          }
        />
        <Path
          fill="#21B6A0"
          fillOpacity=".487"
          d={
            'M53.902 370.418c-.413-2.687-.62-5.167-1.032-7.44-1' +
            '.03-4.548-3.506-8.269-5.775-7.649-3.3.827-4.537 3.' +
            '928-5.362 7.028-1.857 5.994-2.682 12.195-3.507 18.' +
            '81-2.475-3.514-4.537-6.615-6.6-9.509-1.65-2.273-3.' +
            '506-4.34-5.981-5.787-2.682-1.86-3.713-1.24-5.363 1' +
            '.653-2.063 3.928.825 14.056 4.744 17.776.825.827 1' +
            '.856.827 2.681.827 9.9 1.034 19.8.62 29.495-.206.8' +
            '25 0 1.65-.207 2.269-.827 4.537-4.548 8.25-9.508 8' +
            '.456-16.123.206-4.34-2.269-5.994-6.394-4.754-2.269' +
            '.414-3.3 1.24-7.631 6.201z'
          }
        />
        <Path
          fill="#21B6A0"
          fillOpacity=".516"
          d={
            'M662.756 537.7c1.258-1.559 2.202-3.221 3.46-4.676.' +
            '734-.935 1.467-1.767 2.41-2.494 1.888-1.455 3.041-' +
            '1.04 3.356 1.35.419 2.91-.63 5.508-2.412 7.898-.52' +
            '4.624-1.153.624-1.782.727-4.927.416-9.854.312-14.7' +
            '82-.207-.629-.104-1.048-.312-1.572-.728-1.992-1.87' +
            '-3.355-4.156-3.984-6.754-.21-1.143-.21-2.39.839-3.' +
            '221 1.048-.832 2.201-.312 3.354.207 1.258.52 1.887' +
            ' 1.767 3.145 3.326 0-2.079.21-3.43.63-4.884.419-1.' +
            '455.943-3.221 2.62-3.221 1.678 0 2.307 1.662 2.726' +
            ' 3.117 1.049 3.117 1.678 6.235 1.992 9.56z'
          }
        />
        <Path
          fill="#083B39"
          fillOpacity=".3"
          d={
            'M971.962 291.939c0-1.364.21-2.729.525-3.988.21-.94' +
            '4.525-1.784 1.154-2.518 1.05-1.26 1.995-1.365 3.15' +
            '-.105.734.734 1.05 1.679 1.364 2.623.945 3.043 1.5' +
            '75 6.087 1.575 9.34 1.05-.105 1.05-.945 1.365-1.47' +
            ' 1.47-2.203 2.834-4.407 4.934-5.98 1.68-1.155 2.62' +
            '4-.84 3.044 1.049.63 3.148-.42 5.876-2.31 8.395-.4' +
            '2.525-.944.63-1.574.63-5.04.42-10.078.314-15.117-.' +
            '21-.525 0-.945-.21-1.365-.525-2.099-1.994-3.569-4.' +
            '408-4.094-7.346-.21-1.154-.105-2.309.84-2.938.945-' +
            '.735 2.1-.315 3.15.105.84.42 1.47 1.049 2.099 1.78' +
            '4.315.524.525 1.154 1.26 1.154zM91.417 191.295c.21' +
            '-3.506.42-6.187 1.048-8.662.42-1.65 1.048-3.094 1.' +
            '886-4.538 2.096-3.506 4.402-3.506 7.126-.619 1.258' +
            ' 1.444 1.677 3.094 2.305 4.95 1.887 5.982 2.935 11' +
            '.963 3.354 18.77 1.886-1.238 2.305-2.888 3.143-4.1' +
            '25 2.725-3.92 5.24-7.632 9.012-10.52 3.563-2.68 5.' +
            '45-2.062 6.288 2.063 1.257 6.188-1.048 11.55-4.82 ' +
            '16.5-.839 1.032-2.096 1.032-3.144 1.238-10.06.825-' +
            '20.12.619-30.18-.412-.838 0-1.676-.207-2.305-.825-' +
            '4.61-4.126-7.754-9.076-8.593-15.263-.629-4.95 2.51' +
            '5-7.013 7.126-5.363 3.563 1.031 5.24 3.713 7.754 6' +
            '.806z'
          }
        />
        <Path
          fill="#083C39"
          fillOpacity=".3"
          d={
            'M490.94 145.94c2.501-3.065 4.377-6.335 6.879-9.196' +
            ' 1.459-1.839 2.918-3.474 4.794-4.904 3.752-2.656 5' +
            '.837-2.248 6.67 2.248 1.043 5.926-1.042 11.239-4.7' +
            '94 15.939-.833 1.021-1.876 1.226-3.126 1.226-10.00' +
            '6.817-20.012.613-30.018-.205-1.459-.204-2.293-.817' +
            '-3.335-1.839-3.96-3.678-6.253-8.378-7.713-13.486-.' +
            '625-2.248.209-3.883 1.46-5.313 1.459-1.635 3.543-1' +
            '.226 5.628-.613 3.335.817 5.003 3.678 7.712 7.152.' +
            '209-3.679.417-6.335 1.043-8.787.834-3.065 1.667-6.' +
            '744 5.42-6.744 3.543 0 4.794 3.679 5.628 6.54 1.87' +
            '6 5.517 3.127 11.647 3.752 17.982z'
          }
        />
        <Path
          fill="#1D6002"
          fillOpacity=".3"
          d={
            'M497.863 481.49c1.652-.628 2.065-2.093 2.891-3.139' +
            ' 1.24-1.465 2.478-2.512 4.337-3.349 4.543-1.674 7.' +
            '228 0 7.021 4.814-.413 6.488-3.923 11.51-8.467 15.' +
            '906-.62.628-1.445.628-2.271.837-9.706.837-19.413 1' +
            '.465-29.119.21-2.271-.21-3.717-1.256-4.75-2.93-2.6' +
            '84-4.396-4.336-9-3.51-14.232.826-4.605 2.684-5.233' +
            ' 6.402-2.512 3.717 2.93 6.402 6.697 8.88 10.674.82' +
            '6 1.256 1.652 2.72 2.891 4.814 1.033-6.698 1.446-1' +
            '2.558 3.304-18.209.826-2.302 1.24-4.813 3.098-6.69' +
            '7 2.272-2.302 4.13-2.302 5.989.419 1.652 2.302 2.2' +
            '71 4.813 2.684 7.534 0 1.884.414 3.767.62 5.86z'
          }
        />
        <Path
          fill="#1C6001"
          fillOpacity=".3"
          d={
            'M556.424 287.802c.413-3.076.62-5.946 1.239-8.612.6' +
            '19-2.87 1.445-6.356 4.955-6.56 3.097 0 4.335 3.075' +
            ' 5.368 5.74 2.27 6.151 3.51 12.507 4.335 19.273 1.' +
            '446-.615 1.652-1.845 2.271-2.87 2.478-4.306 4.956-' +
            '8.407 8.878-11.687 3.717-3.28 6.194-2.46 6.814 2.4' +
            '6.825 5.536-1.033 10.662-4.336 15.173-.826 1.025-1' +
            '.858 1.23-3.097 1.23-9.704 1.435-19.407 1.025-29.1' +
            '11.82-1.032 0-1.858 0-2.684-.82-4.749-4.1-8.259-8.' +
            '817-8.878-15.378-.413-4.51 2.271-6.355 6.607-4.92 ' +
            '2.064.615 3.51 1.845 4.748 3.28 1.033 1.025 1.24 2' +
            '.46 2.89 2.87z'
          }
        />
        <Path
          fill="#1C6002"
          fillOpacity=".3"
          d={
            'M357.935 375.193c1.664-3.487 2.705-6.153 3.953-8.6' +
            '15 1.248-2.46 2.912-4.717 4.993-6.563 2.912-2.461 ' +
            '5.825-1.846 7.697 1.436 1.248 2.05 1.457 4.307.832' +
            ' 6.768-1.872 8.41-6.865 15.178-12.898 21.126-1.04.' +
            '82-1.872 1.026-3.12.41a83.126 83.126 0 0 0-9.362-3' +
            '.076c-2.08-.616-3.121-2.051-3.537-3.692-3.745-10.0' +
            '5-4.785-20.306-.832-30.56.624-1.847 1.456-4.103 3.' +
            '952-3.898 2.289.205 3.121 2.256 3.745 4.102 2.08 4' +
            '.718 3.12 9.64 3.745 14.768.208 2.05.416 4.307.832' +
            ' 7.794z'
          }
        />
        <Path fill="#B7D8B4" d="M1021.233 16.45c-.9.507-1.799.405-2.81.405.787-.708 1.798-.607 2.81-.404z" />
        <Path
          fill="#2E9533"
          fillOpacity=".3"
          d={
            'M924.298 439.031c0 3.213-46.181 1.762-51.07 1.762-' +
            '10.297-.104-21.218 1.037-31.412.104-4.576-.415-3.8' +
            '48-2.28-2.496-6.633 1.352-4.146 4.369-7.358 8.217-' +
            '9.431 4.265-2.28 8.53-2.798 13.002-1.244 4.368 1.4' +
            '51 2.912 1.97 6.344-1.865 5.513-6.218 14.25-7.67 2' +
            '1.427-3.006 2.808 1.762 4.889 7.359 7.177 8.499 1.' +
            '872.932 6.449-2.488 9.465-2.488 8.529-.103 17.058 ' +
            '6.322 19.346 14.302z'
          }
        />
      </G>
      <Path
        fill="#3F7729"
        d={
          'M344.967 552.322a.412.412 0 0 0-.241-.32c-.861-1.9' +
          '6-2.269-3.429-4.072-4.544l-.501-.506c-.952-1.61-2.' +
          '27-2.806-4.019-3.505a.447.447 0 0 0-.328-.247c-5.3' +
          '4-4.96-11.66-7.094-18.912-6.58-4.886.347-9.489 1.8' +
          '94-14.147 3.227-2.896.825-3.288.474-2.68-2.406.903' +
          '-4.283.933-8.567.105-12.841-.746-3.847-2.475-7.04-' +
          '6.026-9.131-3.438-2.024-7.074-3.045-11.044-2.802-2' +
          '.114.128-2.892-.706-2.699-2.853.158-1.772.072-3.60' +
          '4-.182-5.37-.56-3.919-1.954-7.426-5.603-9.574a.415' +
          '.415 0 0 0-.31-.256c-2.132-2.55-4.862-3.112-7.969-' +
          '2.37-2.74.657-5.167 2.044-7.616 3.373-3.287 1.78-3' +
          '.678 1.655-4.402-1.988-1.887-9.466-6.033-17.725-12' +
          '.284-25.127-10.536-12.472-23.98-15.471-38.968-11.5' +
          '61-12.967 3.38-22.924 12.065-32.086 21.468-2.788 2' +
          '.86-4.963 6.33-6.851 9.907-.19.205-.378.407-.565.6' +
          '14-2.086.447-2.064-1.16-2.325-2.426-1.963-9.493-4.' +
          '202-18.912-7.962-27.884-1.376-3.282-2.862-6.559-5.' +
          '816-8.834-.882-.893-1.766-1.785-2.65-2.678-.809-1.' +
          '403-1.933-2.437-3.478-2.984a.406.406 0 0 0-.319-.2' +
          '38c-5.106-4.873-11.173-7.962-18.217-8.043-7.832-.0' +
          '92-13.707 3.962-17.995 10.395a.427.427 0 0 0-.238.' +
          '328c-2.58 2.287-3.409 5.608-4.996 8.477-1.61 2.912' +
          '-2.04 2.993-4.46.648-3.412-3.308-6.42-7.016-10.464' +
          '-9.682-12.14-8.01-25.446-8.59-39.211-6.413-9.203 1' +
          '.457-17.005 5.542-23.265 12.526-4.034 4.504-7.326 ' +
          '9.572-10.636 14.568-4.521 6.827-7.743 14.393-10.69' +
          '3 22.042-.556 1.437-.956 2.903-.666 4.468-.058 2.2' +
          '44-.166 4.488-.166 6.734C-.004 525.01 0 550.082 0 ' +
          '575.155h12.412c.952-1.048 2.197-.528 3.292-.528 11' +
          '1.042-.027 222.088-.025 333.132-.03 1.167 0 2.334-' +
          '.056 3.501-.087.79.078.859-.475.866-1.03.099-8.16-' +
          '2.516-15.263-8.236-21.158'
        }
      />
      <Path
        fill="#AE916A"
        d={
          'M322.683 562.93c1.804-.199 3.607.32 4.68 1.885 3.5' +
          '42 5.167 2.577 7.674-.406 8.688-2.772.942-5.896-.1' +
          '9-7.603-2.569a1.027 1.027 0 0 0-.047-.067c-2.223-3' +
          '.12-.432-7.52 3.376-7.937zm-62.106-41.577c.09-1.98' +
          ' 1.035-3.22 2.835-3.725 3.189-.894 6.329 1.994 5.8' +
          '44 5.268-.263 1.777-1.175 2.916-2.73 3.415-3.069.9' +
          '84-6.095-1.738-5.95-4.958zm24.274 32.953c3.643 5.8' +
          '6 12.717-.222 7.36-5.204-4.347-4.39-10.045.892-7.3' +
          '6 5.204zm20.654-6.415c-6.194 5.196 4.883 16.115 9.' +
          '01 4.315 2.237-5.595-5.523-8.124-9.01-4.315zm-28.4' +
          '82-19.206c.341-4.105 4.259-7.712 7.972-5.811 2.037' +
          ' 1.042 2.928 3.519 2.372 5.739-.742 2.96-2.872 4.0' +
          '16-4.8 4.555-2.946.827-5.8-1.435-5.544-4.483z'
        }
      />
      <Path
        fill="#6DA148"
        d={
          'M66.643 465.683c.445 5.772-1.914 10.802-3.742 15.9' +
          '58-.209.591-.537 1.203-1.219 1.324-.582.104-.676-.' +
          '479-.827-.881-3.436-9.26-6.404-18.584-3.843-28.644' +
          '.333-1.304.682-2.615 1.174-3.863.52-1.32 1.028-2.9' +
          '81 2.714-3.004 1.801-.022 2.42 1.667 3.013 3.063 1' +
          '.167 2.752 1.677 5.69 2.136 8.618.389 2.483.72 4.9' +
          '85.594 7.43zm151.06-69.278c-9.02-7.526-16.472-15.9' +
          '96-18.055-28.246-.19-1.459-.558-3.276 1.129-4.112 ' +
          '1.492-.74 2.826.312 3.851 1.297 8.362 8.027 13.518' +
          ' 17.577 13.72 29.422.005.35-.071.71-.164 1.054-.04' +
          '2.153-.216.27-.48.585zm-175.815 63.77c6.874 4.546 ' +
          '10.467 11.18 11.706 19.154.517 3.321.64 6.705.99 1' +
          '0.575-1.37-.956-2.533-1.5-3.344-2.373-6.341-6.821-' +
          '11.854-14.208-14.838-23.161-.578-1.734-1.956-3.928' +
          '.108-5.442 1.96-1.432 3.777.187 5.378 1.246zm172.5' +
          '85-54.88c-1.603.204-2.86.087-4.04-.36-8.46-3.207-1' +
          '6.49-7.184-23.115-13.5-1.473-1.405-3.899-2.898-2.7' +
          '05-5.304 1.151-2.325 3.733-1.568 5.855-1.278 7.875' +
          ' 1.075 13.847 5.271 18.424 11.542 1.997 2.736 3.62' +
          '3 5.747 5.581 8.9zm-110.756 136.48c3.843 2.568 7.0' +
          '38 5.799 9.892 9.397.38.479 1.095.93.836 1.576-.30' +
          '6.753-1.187.737-1.89.708-1.161-.047-2.337-.099-3.4' +
          '7-.333-8.313-1.724-14.96-6.206-20.426-12.555-.665-' +
          '.776-1.583-1.716-.89-2.86.587-.967 1.747-.697 3.09' +
          '8-.756 4.446.472 8.826 2.134 12.85 4.823zm88.039-4' +
          '3.137c1.51-.075 1.951 1.448 2.441 2.545 2.11 4.722' +
          ' 2.577 9.709 2.008 14.79-.483 4.297-1.677 8.412-3.' +
          '847 12.36-2.615-4.784-3.95-9.857-4.308-15.166-.277' +
          '-4.072.175-8.092 1.693-11.923.416-1.048.63-2.539 2' +
          '.013-2.606zm-70.874 12.72c1.142-.493 2.13.344 2.86' +
          '2 1.077 6.552 6.527 10.438 14.233 10.208 23.69-.00' +
          '2.142-.195.277-.47.634-6.82-6.087-12.67-12.663-13.' +
          '53-22.307-.098-1.09-.44-2.505.93-3.094zm-11.974 4.' +
          '372c5.478 3.755 8.187 9.144 8.999 15.58.29 2.302.3' +
          '46 4.636.528 7.213-1.214-.281-2.021-.88-2.65-1.601' +
          '-4.745-5.44-9.028-11.184-11.218-18.19-.4-1.284-1.3' +
          '16-2.906.2-3.965 1.529-1.072 2.891.106 4.141.963zm' +
          '118.676-1.674c.855-.541 1.797-1.524 2.896-.685.974' +
          '.744.875 1.98.58 3.004-1.86 6.478-4.569 12.483-10.' +
          '089 16.737-1.666 1.282-3.179 2.865-5.709 3.61 1.71' +
          '6-7.87 3.794-15.063 9.601-20.489.848-.791 1.743-1.' +
          '56 2.721-2.177zm-9.997 1.104c-2.746 4.182-6.937 6.' +
          '626-11.126 9.525-.31-1.33-.247-2.323.072-3.258 2.2' +
          '15-6.492 4.94-12.72 9.53-17.955.352-.402.73-.802 1' +
          '.162-1.117.704-.517 1.394-1.273 2.395-.832 1.047.4' +
          '59 1.288 1.455 1.306 2.473.08 4.072-1.106 7.764-3.' +
          '34 11.164zm15.843-138.794c.184 2.03-.394 3.897-1.2' +
          '17 5.718-2.397 5.297-4.78 10.602-7.168 15.904-1.75' +
          '8-7.971-1.163-15.765 2.435-23.173.677-1.392 1.88-2' +
          '.543 3.68-2.046 1.76.485 2.128 2.007 2.27 3.597zm-' +
          '153.921 92.14c1.396-.814 3.013-1.722 4.492-.484 1.' +
          '559 1.302 1.07 3.065.362 4.711-.544 1.27-1.454 2.2' +
          '58-2.448 3.173-4.677 4.301-9.882 7.941-15.324 12.3' +
          '42 1.846-6.094 4.7-10.888 8.293-15.281 1.365-1.668' +
          ' 2.736-3.36 4.625-4.461z'
        }
      />
      <G>
        <Path
          fill="#6CAC53"
          d={
            'M882.73 430.69c-.145.208-.364.394-.422.623-3.209 1' +
            '2.796-11.324 21.945-21.828 29.29-5.101 3.565-10.63' +
            '2 6.33-16.439 8.554-1.927.74-3.725 1.853-5.87 1.92' +
            '9-5.02-.597-5.02-.597-11.066.147-5.983-.6-11.83-1.' +
            '845-17.592-3.559-2.7-.8-5.046-2.162-7.288-3.818-7.' +
            '781-5.735-13.146-13.315-17.584-21.816-4.398-8.429-' +
            '4.464-16.903-1.602-25.613 2.47-7.517 5.808-14.609 ' +
            '10.447-21.103 6.182-8.654 13.72-14.897 24.648-16.6' +
            '86 10.912-1.788 21.673-2.412 32.366.99 14.518 4.61' +
            '7 23.797 14.755 29.596 28.416 1.2 2.825 1.772 5.91' +
            '8 2.634 8.886v13.76z'
          }
        />
        <Path
          fill="#82743B"
          d={
            'M827.105 471.232c.086-2.305-.182-4.45-1.577-6.478-' +
            '3.047-4.433-6.432-8.509-11.19-11.162-3.328-1.858-7' +
            '.068-2.565-10.802-3.059-1.73-.229-2-.666-.973-2.05' +
            '4.599-.806 1.135-1.693 1.508-2.62.597-1.483 1.563-' +
            '2.009 3.141-1.815 6.582.805 12.543 2.972 17.382 7.' +
            '695 1.168 1.142 1.929 2.584 2.851 3.906.265.377.54' +
            '8.909 1.064.794.618-.138.415-.769.407-1.202-.152-7' +
            '.802-.641-15.587-1.096-23.375-.292-4.97-.397-9.953' +
            '-.538-14.931-.101-3.558-.054-3.574 3.625-4.022 4.0' +
            '5-.494 4.053-.494 4.048 3.614-.005 5.246-.002 10.4' +
            '92 1.192 15.647.197.857.305 1.894 1.327 2.058 1.01' +
            '4.16 1.494-.79 1.938-1.521 4.5-7.439 11.735-10.054' +
            ' 19.774-11.328 1.968-.312 2.928.628 3.784 2.193 2.' +
            '13 3.897 2.198 4.047-2.172 4.632-9.863 1.324-15.83' +
            '3 7.688-20.616 15.61-1.075 1.782-.418 3.962-.676 5' +
            '.952-.914 7.068-1.313 14.186-1.335 21.32-.607 4.74' +
            '-.554 9.517-.803 14.276-.472 9.01-.821 18.027-1.17' +
            '2 27.042-.052 1.307-.484 1.898-1.838 2.1a38.368 38' +
            '.368 0 0 0-5.695 1.324c-1.439.45-1.894.243-1.825-1' +
            '.368.602-13.867.354-27.742.34-41.616 0-.536-.046-1' +
            '.076-.073-1.612'
          }
        />
        <Path
          fill="#2B9B24"
          d={
            'M818.737 433.16c.2 1.488-.012 2.13-1.919 1.753-4.2' +
            '3-.838-6.973-3.597-9.472-6.701-2.174-2.702-3.746-5' +
            '.76-4.12-9.282-.31-2.913.423-5.62 2.07-8.012.87-1.' +
            '262 2.04-1.597 3.453-.547 1.482 1.103 2.772 2.356 ' +
            '3.671 3.963 3.118 5.576 4.764 11.677 6.305 17.814.' +
            '081.315.012.669.012 1.011zm21.058-21.522c-1.05-7.2' +
            '6 1.533-13.719 4.474-20.083.56-1.211 1.332-2.334 2' +
            '.095-3.437 1.01-1.466 1.681-1.43 2.323.192 1.48 3.' +
            '734 1.818 7.506.412 11.395-1.811 5.007-5.474 8.524' +
            '-9.257 11.982l-.047-.05zm18.65 1.686c-2.677-.462-5' +
            '.343-1.06-8.119-.924-1.17.055-.56-.896-.3-1.267.92' +
            '6-1.325 2.025-2.576 3.425-3.362 3.573-2.007 7.271-' +
            '3.673 11.572-2.994 1.172.186 2.404.466 2.964 1.45.' +
            '646 1.137-.325 2.19-.985 3.073-2.116 2.838-4.957 4' +
            '.23-8.558 4.024z'
          }
        />
      </G>
      <G>
        <Path
          fill="#308938"
          d={
            'M252.503 86.076c26.488 0 33.573 9.58 41.566 43.11 ' +
            '7.994 33.53-15.078 28.74-41.566 28.74-3.54 0-26.15' +
            '5 4.79-44.764 4.79-27.477 0-45.69-1.843-55.697-5.9' +
            '67-17.94-7.395-14.646-22.124-14.646-46.723 0-38.32' +
            ' 21.473-52.69 47.96-52.69 21.252 0 39.274 14.264 4' +
            '5.57 34.02a46.56 46.56 0 0 1 21.577-5.28z'
          }
        />
        <Path
          fill="#8E7453"
          d={
            'M207.647 169.275l-20.952-44.973 12.894-4.819 17.72' +
            '9 35.336 24.176-27.305 6.447 12.85-19.341 14.455-4' +
            '.835 61.036h-16.118z'
          }
        />
        <Path
          fill="#5AAF51"
          d={
            'M176.437 99.586c-2.206.847-5.945-3.549-8.352-9.818' +
            '-2.406-6.27-2.569-12.038-.363-12.885 2.206-.847 5.' +
            '945 3.55 8.351 9.818 2.407 6.27 2.57 12.038.364 12' +
            '.885zm-6.998 18.886c-1.355 1.935-6.913.382-12.414-' +
            '3.47-5.5-3.851-8.861-8.543-7.506-10.478 1.355-1.93' +
            '6 6.913-.382 12.414 3.47 5.501 3.851 8.862 8.543 7' +
            '.506 10.478zm24.43-19.695c-2.31-.491-3.052-6.214-1' +
            '.656-12.783 1.396-6.568 4.401-11.495 6.712-11.004 ' +
            '2.312.491 3.053 6.215 1.657 12.783-1.396 6.569-4.4' +
            '01 11.495-6.713 11.004zm19.944 12.913c-2.292-.572-' +
            '2.834-6.318-1.21-12.833 1.625-6.516 4.8-11.335 7.0' +
            '93-10.763 2.293.571 2.835 6.317 1.21 12.833-1.625 ' +
            '6.515-4.8 11.334-7.093 10.763zm28.907 1.397c-2.34-' +
            '.33-3.605-5.088-2.826-10.63.779-5.541 3.307-9.767 ' +
            '5.647-9.438 2.34.329 3.605 5.088 2.826 10.63-.779 ' +
            '5.54-3.307 9.767-5.647 9.438zm21.236 14.176c-2.158' +
            '-.96-1.694-6.713 1.037-12.848 2.732-6.134 6.696-10' +
            '.328 8.854-9.367 2.159.96 1.694 6.713-1.037 12.848' +
            '-2.731 6.134-6.695 10.328-8.854 9.367zm.828 17.221' +
            'c-1.217-2.025 2.463-6.47 8.219-9.93 5.756-3.458 11' +
            '.409-4.62 12.626-2.594 1.217 2.025-2.463 6.47-8.22' +
            ' 9.93-5.755 3.458-11.408 4.62-12.625 2.594z'
          }
        />
      </G>
    </G>
  </Svg>
);

BgLogins.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

BgLogins.defaultProps = {
  width: 1024,
  height: 576,
};

export default BgLogins;
